import { render, staticRenderFns } from "./exchange-foreign-interests.pug?vue&type=template&id=42d19b3c&scoped=true&lang=pug&external"
import script from "./exchange-foreign-interests.js?vue&type=script&lang=js&external"
export * from "./exchange-foreign-interests.js?vue&type=script&lang=js&external"
import style0 from "./exchange-foreign-interests.scss?vue&type=style&index=0&id=42d19b3c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d19b3c",
  null
  
)

export default component.exports